import { useState } from 'react'
import { Canvas } from '@react-three/fiber'
import ScrollController from './ScrollController'
import Experience from './Experience'
import LoadingAssets from './LoadingAssets'
import DebugPanel from './DebugPanel'

export default function PortfolioCanvas({ onLoadingScreenProgressUpdate, onAssetsLoaded }) {
    const [isLoadingAssets, setIsLoadingAssets] = useState(true)

    const handleLoadingScreenProgressUpdate = (progress, loadingText) => {
        onLoadingScreenProgressUpdate(progress, loadingText)
    }

    const handleAssetsLoaded = () => {
        // console.log("PortfolioCanvas.handleLoadingComplete ", loadedTextures.length)
        setIsLoadingAssets(false)
        onAssetsLoaded()
    }

    // TODO: do ScrollController only places that calculates scrollCameraUnits, now is doing it DebugPanel AND Experience because it has to be inside Canvas
    const scrollController = new ScrollController()
    // console.log(scrollController)
    // console.log(scrollController.bioAndContactSectionCameraUnitsHeight)

    return (<Canvas
        gl={{ alpha: true }}
        // default camera setup
        camera={{
            fov: 35,
            // near: 0.1,
            // far: 1000,
            // position: [0, 0, 5]
            // position: [0, 0, -6.35]
            position: [0, 0, 6.35]
        }}>
        {isLoadingAssets ? (
            <LoadingAssets
                onLoadingScreenProgressUpdate={handleLoadingScreenProgressUpdate}
                onAssetsLoaded={handleAssetsLoaded}
            />
        ) : (
            <>
                {/* <DebugPanel
                    scrollController={scrollController}
                /> */}
                <Experience
                    scrollController={scrollController}
                />
            </>
        )}
    </Canvas>)
}
